import { Grid } from "@mui/material";
import React from "react";
import moment from "moment";
import QTDetailsTextFieldWithLabelSection from "../../../../../common/QTDetailsTextFieldWithLabelSection";

const GAUserDetailsInteractionFieldsSection = ({
  userDetails,
  groups,
  likes,
}) => {
  return (
    <Grid container style={dataContainerStyles}>
      {/*left side column*/}
      <Grid item container direction={"column"} xs>
        {/* Groups section*/}
        <QTDetailsTextFieldWithLabelSection
          label={"Groups"}
          value={groups}
          disabled={true}
        />
        {/* Following section*/}
        <QTDetailsTextFieldWithLabelSection
          label={"Following"}
          value={
            userDetails?.following?.length ? userDetails?.following?.length : 0
          }
          disabled={true}
        />
        {/* Followers section*/}
        <QTDetailsTextFieldWithLabelSection
          label={"Followers"}
          value={
            userDetails?.followedBy?.length
              ? userDetails?.followedBy?.length
              : 0
          }
          disabled={true}
        />
      </Grid>
      {/*right side column*/}
      <Grid item container direction={"column"} xs>
        {/* Likes section*/}
        <QTDetailsTextFieldWithLabelSection
          label={"Likes"}
          value={likes}
          disabled={true}
        />
        {/* Date signup section*/}
        <QTDetailsTextFieldWithLabelSection
          label={"Date Signup"}
          value={
            userDetails?.createdAt &&
            moment.unix(userDetails?.createdAt?.seconds).format("MM-DD-YYYY HH:mm:ss")
          }
          disabled={true}
        />
      </Grid>
    </Grid>
  );
};

export default GAUserDetailsInteractionFieldsSection;

const dataContainerStyles = {
  borderRadius: 12,
  boxShadow: " 0px 0px 30px 0px rgba(80, 85, 136, 0.15)",
  background: "var(--gray-99, #FCFCFC)",
  padding: "36px 15px",
  marginBottom: 30,
};
